const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/qr/KP7ZNZ7ZYHHCN1"
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="Falar com especialista no WhatsApp"
      className="fixed bottom-8 right-8 z-50 w-16 h-16 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 hover:scale-110"
      style={{
        background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
        boxShadow: '0 8px 32px rgba(37, 211, 102, 0.35)',
        animation: 'whatsappPulse 2.5s ease-in-out infinite',
      }}
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
      <style>{`
        @keyframes whatsappPulse {
          0%, 100% { box-shadow: 0 8px 32px rgba(37,211,102,0.35); }
          50% { box-shadow: 0 8px 48px rgba(37,211,102,0.6); }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppButton;
